import React from 'react';
import { US_STATES } from '../../data/usStates';

const labels = { street: 'Street', city: 'City', state: 'State', zipCode: 'ZIP code' };

export default function DistributorAddressFields({ address, onChange, t, inputClass }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-[minmax(0,1.5fr)_minmax(0,1fr)_minmax(0,0.8fr)]">
      {Object.entries(labels).map(([key, label]) => (
        <label key={key} className={`block min-w-0 ${key === 'street' ? 'sm:col-span-3' : ''}`}>
          {t(label)}
          {key === 'state' ? (
            <select
              className={inputClass}
              value={address.state || ''}
              onChange={(event) => onChange('state', event.target.value)}
            >
              <option value="">{t('Select state')}</option>
              {US_STATES.map(([code, name]) => (
                <option key={code} value={code}>
                  {name}
                </option>
              ))}
            </select>
          ) : (
            <input
              className={inputClass}
              value={address[key] || ''}
              maxLength={{ street: 120, city: 80, zipCode: 10 }[key]}
              onChange={(event) => onChange(key, event.target.value)}
            />
          )}
        </label>
      ))}
    </div>
  );
}
